<template>
  <div class="annual-report-content">
    <!-- Tab 切换 -->
    <div class="tabs-container">
      <div class="tabs-header">
        <button 
          v-for="tab in tabs" 
          :key="tab.id"
          :class="['tab-btn', { active: activeTab === tab.id }]"
          @click="activeTab = tab.id"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Tab 内容 -->
      <div class="tabs-content">
        <!-- 柱状统计 -->
        <div v-show="activeTab === 'chart'" class="tab-pane">
          <div class="table-header">
            <h2>2025-9月 至 2026-6月 院校分布统计</h2>
            <div class="total-count">总单量: {{ totalCount }}</div>
          </div>
          <div id="schoolChart2025" style="width: 100%; height: 1200px;"></div>
        </div>

        <!-- 表格展示 -->
        <div v-show="activeTab === 'table'" class="tab-pane">
          <div class="table-header">
            <h2>2025-9月 至 2026-6月 院校分布统计</h2>
            <div class="total-count">总单量: {{ totalCount }}</div>
          </div>
          <div class="table-wrapper">
            <table class="data-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>学校名称</th>
                  <th>数量</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in schoolData" :key="item.rank">
                  <td>{{ item.rank }}</td>
                  <td>{{ item.name }}</td>
                  <td class="number">{{ item.count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 词云图展示 -->
        <div v-show="activeTab === 'wordcloud'" class="tab-pane">
          <div class="table-header">
            <h2>2025-9月 至 2026-6月 院校分布统计</h2>
            <div class="total-count">总单量: {{ totalCount }}</div>
          </div>
          <div id="wordcloudChart2025" class="wordcloud-container"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnualReport2025_2026',
  data() {
    return {
      activeTab: 'chart',
      wordCloudChart: null,
      barChart: null,
      tabs: [
        { id: 'chart', label: '柱状统计' },
        { id: 'table', label: '表格展示' },
        { id: 'wordcloud', label: '词云图展示' }
      ],
      schoolData: [
        { rank: 1, name: '未知院校', count: 40 },
        { rank: 2, name: '重庆工程学院', count: 29 },
        { rank: 3, name: '齐齐哈尔医学院', count: 19 },
        { rank: 4, name: '江西科技学院', count: 11 },
        { rank: 5, name: '天津仁爱学院', count: 11 },
        { rank: 6, name: '南京航空航天大学金城学院', count: 8 },
        { rank: 7, name: '淮阴工学院', count: 6 },
        { rank: 8, name: '牡丹江师范学院', count: 7 },
        { rank: 9, name: '温州商学院', count: 6 },
        { rank: 10, name: '重庆机电职业技术大学', count: 6 },
        { rank: 11, name: '仰恩大学', count: 5 },
        { rank: 12, name: '重庆移通学院', count: 5 },
        { rank: 13, name: '中国石油大学', count: 4 },
        { rank: 14, name: '北华航天工业学院', count: 3 },
        { rank: 15, name: '成都东软学院', count: 3 },
        { rank: 16, name: '哈尔滨广厦学院', count: 3 },
        { rank: 17, name: '黑龙江中医药大学', count: 3 },
        { rank: 18, name: '大连东软信息学院', count: 2 },
        { rank: 19, name: '南京信息工程学院', count: 2 },
        { rank: 20, name: '西北民族大学', count: 2 },
        { rank: 21, name: '西南石油大学', count: 2 },
        { rank: 22, name: '郑州商学院', count: 2 },
        { rank: 23, name: '大庆师范学院', count: 1 },
        { rank: 24, name: '河北传媒学院', count: 1 },
        { rank: 25, name: '河北科技大学', count: 1 },
        { rank: 26, name: '江苏海洋大学', count: 1 },
        { rank: 27, name: '南通大学杏林学院', count: 1 },
        { rank: 28, name: '南通理工学院', count: 1 },
        { rank: 29, name: '云南大学滇池学院', count: 1 },
        { rank: 30, name: '重庆涉外商贸学院', count: 1 }
      ]
    }
  },
  computed: {
    totalCount() {
      return this.schoolData.reduce((sum, item) => sum + item.count, 0)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  watch: {
    activeTab(newVal) {
      if (newVal === 'wordcloud') {
        this.$nextTick(() => {
          this.initWordCloud()
        })
      } else if (newVal === 'chart' && !this.barChart) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    }
  },
  beforeDestroy() {
    if (this.barChart) {
      this.barChart.dispose()
      this.barChart = null
    }
    if (this.wordCloudChart) {
      this.wordCloudChart.dispose()
      this.wordCloudChart = null
    }
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById('schoolChart2025')
      if (!chartDom) return
      
      if (this.barChart) {
        this.barChart.dispose()
      }
      
      this.barChart = this.$echarts.init(chartDom)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: 20,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: this.schoolData.map(item => item.name).reverse(),
          axisLabel: {
            interval: 0,
            fontSize: 12
          }
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            data: this.schoolData.map(item => item.count).reverse(),
            itemStyle: {
              color: '#667eea'
            },
            label: {
              show: true,
              position: 'right',
              fontSize: 12
            }
          }
        ]
      }
      this.barChart.setOption(option)
      
      window.addEventListener('resize', () => {
        if (this.barChart) {
          this.barChart.resize()
        }
      })
    },
    initWordCloud() {
      const chartDom = document.getElementById('wordcloudChart2025')
      if (!chartDom) return
      
      if (this.wordCloudChart) {
        this.wordCloudChart.dispose()
        this.wordCloudChart = null
      }
      
      setTimeout(() => {
        this.wordCloudChart = this.$echarts.init(chartDom)
        
        const wordCloudData = this.schoolData.map(item => ({
          name: `${item.name} ${item.count}单`,
          value: item.count
        }))
        
        const shuffledData = wordCloudData.sort(() => Math.random() - 0.5)
        const isMobile = window.innerWidth <= 768
        
        const option = {
          tooltip: {
            show: true,
            formatter: function(params) {
              return params.name
            }
          },
          series: [{
            type: 'wordCloud',
            shape: 'circle',
            left: 'center',
            top: 'center',
            width: isMobile ? '95%' : '90%',
            height: isMobile ? '95%' : '90%',
            right: null,
            bottom: null,
            sizeRange: isMobile ? [10, 32] : [14, 60],
            rotationRange: [0, 0],
            rotationStep: 0,
            gridSize: isMobile ? 8 : 20,
            drawOutOfBound: false,
            layoutAnimation: true,
            textStyle: {
              fontFamily: 'Microsoft YaHei, PingFang SC, sans-serif',
              fontWeight: isMobile ? 'normal' : 'bold',
              color: function () {
                const colors = [
                  '#667eea', '#764ba2', '#f093fb', '#4facfe',
                  '#43e97b', '#fa709a', '#30cfd0', '#c471f5',
                  '#12c2e9', '#ff6b6b', '#4ecdc4', '#45b7d1',
                  '#f38181', '#aa96da', '#fcbad3', '#a8d8ea',
                  '#ffaaa5', '#ffd3b6', '#a8e6cf', '#ff8b94',
                  '#5f27cd', '#00d2d3', '#ff9ff3', '#54a0ff',
                  '#48dbfb', '#1dd1a1', '#ee5a6f', '#c44569',
                  '#f368e0', '#ff6348'
                ]
                return colors[Math.floor(Math.random() * colors.length)]
              }
            },
            emphasis: {
              focus: 'self',
              textStyle: {
                textShadowBlur: isMobile ? 5 : 10,
                textShadowColor: '#333'
              }
            },
            data: shuffledData
          }]
        }
        
        this.wordCloudChart.setOption(option)
        
        window.addEventListener('resize', () => {
          if (this.wordCloudChart) {
            this.wordCloudChart.resize()
          }
        })
      }, 100)
    }
  }
}
</script>

<style scoped>
/* Tab 切换 */
.tabs-container {
  background: #fff;
  border: 1px solid #e5e7eb;
}

.tabs-header {
  display: flex;
  gap: 0;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}

.tab-btn {
  flex: 1;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
  background: #fff;
  border: none;
  border-right: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.3s;
}

.tab-btn:last-child {
  border-right: none;
}

.tab-btn:hover {
  color: #2563eb;
  background: #f9fafb;
}

.tab-btn.active {
  color: #fff;
  background: #2563eb;
  font-weight: 500;
}

.tabs-content {
  padding: 40px;
  min-height: 400px;
}

.tab-pane {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 表格样式 */
.table-header {
  text-align: center;
  margin-bottom: 20px;
}

.table-header h2 {
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: 700;
}

.total-count {
  font-size: 18px;
  color: #666;
  font-weight: 500;
}

.table-wrapper {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.data-table thead {
  background: #e8eaf6;
}

.data-table th {
  padding: 16px 12px;
  text-align: left;
  color: #5c6bc0;
  font-weight: 600;
  font-size: 16px;
  border-bottom: 2px solid #5c6bc0;
}

.data-table th:first-child {
  width: 80px;
  text-align: center;
}

.data-table th:last-child {
  width: 100px;
  text-align: center;
}

.data-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}

.data-table tbody tr:hover {
  background-color: #f8f9ff;
}

.data-table td {
  padding: 14px 12px;
  color: #555;
  font-size: 15px;
}

.data-table td:first-child {
  text-align: center;
  font-weight: 600;
  color: #999;
}

.data-table td:nth-child(2) {
  color: #333;
  font-weight: 500;
}

.data-table td.number {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  color: #667eea;
}

/* 词云图容器 */
.wordcloud-container {
  width: 100%;
  height: 800px;
  min-height: 600px;
}

@media screen and (max-width: 768px) {
  .wordcloud-container {
    height: 600px;
    min-height: 500px;
  }
  
  .tabs-content {
    padding: 20px;
    min-height: 300px;
  }

  .tab-btn {
    padding: 12px 16px;
    font-size: 14px;
  }
}
</style>
